<p-sidebar [(visible)]="visible" [position]="drawerPosition" [transitionOptions]="'300ms cubic-bezier(0.25, 0.8, 0.25, 1)'" [baseZIndex]="10000" styleClass="user-menu-sidebar u-drawer" [showCloseIcon]="false" (onHide)="closeSidebar()">

  <!-- Cream header: user identity card + close -->
  <div class="drawer-head cream">
    <div class="u-card">
      <span class="u-avatar">
        <i class="fa fa-user-circle-o" aria-hidden="true"></i>
      </span>
      @if (sessionService.getSession && userProperty.userSelectedCompany) {
        <div class="u-info">
          <span class="u-name">{{ sessionService.fullName }}</span>
          <span class="u-email">{{ sessionService.email }}</span>
          <span class="u-badge">{{ userProperty.userSelectedCompany.name }}</span>
        </div>
      }
    </div>
    <button class="drawer-close" (click)="closeSidebar()" [attr.aria-label]="'app.close' | translate">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="drawer-body">

    <!-- Quick actions: account (orange) + sign out (red) -->
    <div class="u-actions">
      <button class="pill orange" (click)="navigateToAccountSettings()">
        <i class="pi pi-cog" aria-hidden="true"></i>
        <span>{{ "account.my-account" | translate }}</span>
      </button>
      <button class="pill red" (click)="signOut()">
        <i class="pi pi-sign-out" aria-hidden="true"></i>
        <span>{{ 'app.signOut' | translate }}</span>
      </button>
    </div>

    @if (canManageAccountSettings) {
      <button class="pill pill-block" (click)="changePassword()">
        <i class="pi pi-lock" aria-hidden="true"></i>
        <span>{{ "account.changepassword" | translate }}</span>
      </button>
    }

    <!-- Mobile-only: Impersonate actions -->
    @if (appProperty.impersonateIsActive) {
      <div class="um-section">
        <button pButton pRipple [loading]="appComponent.impersonateLoader"
          icon="pi pi-user-minus"
          label="{{ 'account.remove-impersonate' | translate }}"
          class="um-impersonate-btn um-impersonate-remove p-button-sm"
          (click)="appComponent.removeImpersonate(); closeSidebar()">
        </button>
      </div>
    }

    <!-- Mobile-only: OAuth providers -->
    @if (appStateHolder.oauthState.providers.length > 0) {
      <div class="um-section um-oauth-section">
        @for (provider of appStateHolder.oauthState.providers; track provider.provider) {
          <div class="um-oauth-item"
            [class.oauth-active]="appComponent.getOAuthProviderStatus(provider.provider) === 'active'"
            [class.oauth-expiring]="appComponent.getOAuthProviderStatus(provider.provider) === 'expiring'"
            [class.oauth-expired]="appComponent.getOAuthProviderStatus(provider.provider) === 'expired'"
            (click)="appComponent.showOAuthPanel($event, provider.provider)">
            @if (provider.provider === 'Office365' || provider.provider === 'Microsoft') {
              <img src="assets/CustomIcons/microsoftprovider.svg" class="um-oauth-icon" alt="Microsoft" />
              <span class="um-oauth-name">Microsoft</span>
            }
            @if (provider.provider === 'Jira' || provider.provider === 'Atlassian') {
              <img src="assets/CustomIcons/jiraprovider.svg" class="um-oauth-icon" alt="Jira" />
              <span class="um-oauth-name">Jira</span>
            }
            <span class="um-oauth-dot"></span>
          </div>
        }
      </div>
    }

    <!-- Company switcher -->
    <div class="u-section">{{ 'app.selectCompany' | translate }}</div>
    <div class="u-list">
      @for (company of userProperty.userCompaniesList; track $index) {
        <button class="u-row"
          [class.active]="userProperty.userSelectedCompany && company.id === userProperty.userSelectedCompany.id"
          (click)="appComponent.changeCompany(company)">
          <span class="ic">
            <i class="fa fa-building-o" aria-hidden="true"></i>
          </span>
          <span class="nm">{{ company.name }}</span>
          @if (userProperty.userSelectedCompany && company.id === userProperty.userSelectedCompany.id) {
            <span class="check" aria-hidden="true">
              <i class="pi pi-check"></i>
            </span>
          }
        </button>
      }
    </div>

  </div>

</p-sidebar>
